@if (title) {
  <div matDialogTitle>{{title}}</div>
}
<div>
 @if (savingMessage?.length > 0) {
    @for (item of savingMessage; track item) {
      <p-message [severity]="item.severity">{{item.summary}}</p-message>
    }
}
</div>
<mat-dialog-content>
  @if (mode == 'confirmDeleteAssetImports') {
    <div class="modal-text" [ngStyle]="textStyle">
      Are you sure you want to delete this Asset Import?<br><br>This will <span style="color: red;">permanently delete</span> all associated Assets which have yet to be reviewed/accepted.<br><br> All accepted Assets will remain on the Asset Index.
    </div>
  }

  @if (message) {
    <div class="modal-text" [ngStyle]="textStyle">{{message}}</div>
  }

  @if (htmlMessage) {
    <div class="modal-text" [ngStyle]="textStyle"><p [innerHTML]="htmlMessage"></p></div>
  }
  @for (msgData of transactionMessage; track msgData) {
    <ul class="modal-text">
      <li>{{msgData}}</li>
    </ul>
  }
  @for (msgData of charSetMessage; track msgData) {
    <div class="modal-text">
      {{msgData}}
    </div>
  }
  @for (msg of warningMessage; track msg) {
    <ul class="modal-text">
      <li style="color: red;">{{msg}}</li>
    </ul>
  }
  @for (msg of messageBulleted; track msg) {
    <ul class="modal-text">
      <li>{{msg}}</li>
    </ul>
  }
</mat-dialog-content>
<div class="layout-row-end-none gap-20">
  @if (allowCancel) {
    <button [disabled]="saveDisabled" mat-raised-button (click)="dialogRef.close(false)">{{cancelButton}}</button>
  }
  @if (isShowRemoveButton) {
    <button mat-raised-button [color]="removeColor" (click)="save()" [disabled]="saveDisabled">{{removeButton}}</button>
  }
  <button mat-raised-button [color]="confirmColor" (click)="save(deleteLedger)" [disabled]="saveDisabled">{{confirmButton}}</button>
</div>
